import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[greaterThanDate][formControlName],[greaterThanDate][formControl],[greaterThanDate][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => GreaterThanDate), multi: true }
  ]
})
export class GreaterThanDate implements Validator {
  constructor(@Attribute('greaterThan') public controlName: string) { }

  @Input('controlField')
  controlField: AbstractControl;

  validate(control: AbstractControl): { [key: string]: any } {
    if (!control.value) {
      return null;
    }
    const controlValue = this.controlField.value as NgbDateStruct;
    const controlDate = new Date(controlValue.year, controlValue.month - 1, controlValue.day);
    const formValue = control.value as NgbDateStruct;
    const formDate = new Date(formValue.year, formValue.month - 1, formValue.day);

    if (isNaN(formDate.getTime())) {
      return null;
    }

    // Damit ein Fehler vorliegt muss das, im Formular gesetzte Datum kleiner sein, als das Kontrolldatum
    if (!isNaN(controlDate.getTime()) && !isNaN(formDate.getTime()) && formDate < controlDate) {
      return { greaterThanDate: true };
    }

    return null;
  }
}